const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || process.env.NEXT_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_KEY;

// Edge Function czeka na n8n do 40 s; przeglądarka przerywa po 45 s.
export const CHAT_TIMEOUT_MS = 45_000;
export const CHAT_MESSAGE_MAX = 1000;

export class ChatError extends Error {
  constructor(message, { status = 0, limit = null, timeout = false } = {}) {
    super(message);
    this.status = status;
    this.limit = limit;
    this.timeout = timeout;
  }
}

/**
 * Wysyła wiadomość do Edge Function submit-chat (ta przekazuje ją do n8n; token n8n nie trafia
 * do przeglądarki). Zwraca tekst odpowiedzi TYLKO przy { ok: true, reply: "<tekst>" };
 * każdy inny kształt, status różny od 2xx, brak sieci lub timeout rzuca ChatError.
 */
export async function sendChatMessage({ message, sessionId, sourcePage }) {
  if (!supabaseUrl || !supabaseAnonKey) throw new ChatError("Brak konfiguracji czatu.");
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), CHAT_TIMEOUT_MS);
  try {
    const response = await fetch(`${supabaseUrl}/functions/v1/submit-chat`, {
      method: "POST",
      headers: { "Content-Type": "application/json", apikey: supabaseAnonKey, Authorization: `Bearer ${supabaseAnonKey}` },
      body: JSON.stringify({ message, sessionId, source_page: sourcePage }),
      signal: controller.signal,
    });
    const data = await response.json().catch(() => null);
    if (!response.ok) throw new ChatError(data?.error || "Czat jest chwilowo niedostępny.", { status: response.status, limit: data?.limit || null });
    if (data?.ok !== true || typeof data?.reply !== "string" || !data.reply.trim()) throw new ChatError("Nie otrzymaliśmy odpowiedzi.", { status: response.status });
    return data.reply.trim();
  } catch (error) {
    if (error instanceof ChatError) throw error;
    if (error?.name === "AbortError") throw new ChatError("Odpowiedź trwa zbyt długo.", { timeout: true });
    throw new ChatError("Brak połączenia z serwerem.");
  } finally {
    clearTimeout(timer);
  }
}
